jQuery( ".newsletter_reveal" ).click(function() {
    jQuery( ".newsletter_reveal_section" ).show();
    jQuery( ".newsletter_reveal" ).hide();
    var newsletter_section_height = jQuery( ".newsletter_reveal_section" ).height();
    jQuery( ".newsletter_reveal_section" ).height('0px');
    jQuery( ".newsletter_reveal_section" ).animate({
        height: (newsletter_section_height + "px")
      }, 500, function() {
        // Animation complete.
      });s
});